import Hero from './headfoot/Home'
import Footer from './headfoot/Footer'
// import Feature from './Feature'

export default function Home() {
  return (
    <>
      <Hero />
      {/* <Feature /> */}
      <Footer />
    </>
  )
}
